import { CarouselCardWrapper } from '@components/primitives/Carousel/CarouselCardWrapper.client'
import { CloudflareImage } from '@components/primitives/Image/Cloudflare'
import Link from '@components/primitives/Link'
import { MediaCard } from '@components/primitives/MediaCard'
import type { Gradients } from '@lib/colors/colors'
import type { Url } from '@lib/routes'
import { type TrackingSources } from '@lib/tracking/TrackingSources'
import ArticleCardWrapper from './ArticleCardWrapper.client'

export interface ArticleCardProps {
  backgroundGradient?: Gradients
  description: string
  href: Url
  index?: number
  trackingSource: TrackingSources
}

const GUIDE_IMAGES = [
  'ea43abe4-6beb-4d12-3cdb-283100f32800',
  'f3404653-0de8-4c45-2676-cbe5091ba600',
  'a2a2366c-021f-4d31-de82-a8c8f6000e00',
  '3317d953-4cd6-46d4-b4c6-220eed841b00',
  '2363176d-b64a-49fd-f4d4-5529589cf900',
  'c6a63a80-7e77-4667-2ba2-f545b6fcaa00',
  '6dbb5771-6812-4743-31e3-136943335600',
  '089df82f-4d2c-46b2-a756-c84c1c97bf00',
  '6c3f3c19-dc34-4175-2ea7-f86169c02500',
]

/** Article card used to show Graphite Interlinking articles **/
export function ArticleCard({
  description,
  href,
  index,
  trackingSource,
}: ArticleCardProps) {
  return (
    <ArticleCardWrapper path={href.toString()} source={trackingSource}>
      <CarouselCardWrapper>
        <Link href={href}>
          <MediaCard
            className='border border-neutral200'
            desc={description}
            subtitle=''
          >
            <CloudflareImage
              alt={description}
              className='w-full rounded-t-lg'
              height={200}
              imageId={GUIDE_IMAGES[(index ?? 0) % GUIDE_IMAGES.length]!}
              width={300}
            />
          </MediaCard>
        </Link>
      </CarouselCardWrapper>
    </ArticleCardWrapper>
  )
}
